export default __webpack_public_path__ + "static/media/wordpress-logo.22c6b7d8.png";